import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { useT } from '../i18n/translations';
import { FOOTER_LINKS, PAYMENT_LOGOS, SOCIAL_LINKS } from '../data/catalog';
import Icon from './Icon';
import './Footer.css';

export default function Footer() {
  const { lang, navigate, openDrawer, user, subscribeNewsletter } = useApp();
  const t = useT(lang);
  const [email, setEmail] = useState('');
  const [subBusy, setSubBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubBusy(true);
    const ok = await subscribeNewsletter(email);
    setSubBusy(false);
    if (ok) setEmail('');
  };

  const handleLink = (target) => {
    switch (target?.type) {
      case 'info':
        navigate('info', { topic: target.id });
        break;
      case 'product':
        navigate('product', { id: target.id });
        break;
      case 'category':
        navigate('category', { id: target.id });
        break;
      case 'account':
        if (user) {
          openDrawer('account');
        } else {
          openDrawer('auth');
        }
        break;
      case 'chat':
        openDrawer('chat');
        break;
      default:
        navigate('home');
    }
  };

  return (
    <footer className="nx-footer">
      <div className="nx-footer__cta">
        <div className="container nx-footer__cta-inner">
          <div>
            <h3>{t.footer.newsletter}</h3>
            <p>{t.footer.newsletterHint}</p>
          </div>
          <form className="nx-footer__news" onSubmit={submit}>
            <Icon name="mail" size={16} />
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button className="btn btn-primary btn-sm" type="submit" disabled={subBusy}>
              {subBusy ? '處理中…' : t.footer.subscribe}
            </button>
          </form>
        </div>
      </div>

      <div className="container nx-footer__main">
        <div className="nx-footer__brand">
          <button
            type="button"
            className="nx-logo"
            onClick={() => navigate('home')}
            aria-label="QQCARD Home"
          >
            <span className="nx-logo__mark" />
            <span className="nx-logo__name">QQCARD</span>
          </button>
          <p className="nx-footer__tag">{t.tagline}</p>
          <div className="nx-footer__social">
            {SOCIAL_LINKS.map((s) => (
              <a
                key={s.name}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.name}
                title={s.name}
              >
                <Icon name={s.icon} size={17} />
              </a>
            ))}
          </div>
          <div className="nx-footer__cert">
            <span className="nx-footer__chip">
              <Icon name="shield" size={11} /> SSL Encrypted
            </span>
            <span className="nx-footer__chip">
              <Icon name="lock" size={11} /> PCI DSS Lv1
            </span>
            <span className="nx-footer__chip">
              <Icon name="check" size={11} /> ISO 27001
            </span>
          </div>
        </div>

        <div className="nx-footer__cols">
          {Object.entries(FOOTER_LINKS).map(([k, col]) => (
            <div key={k} className="nx-footer__col">
              <h4>{col.title}</h4>
              <ul>
                {col.links.map((l) => (
                  <li key={l.label}>
                    <button type="button" onClick={() => handleLink(l.target)}>
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="nx-footer__pay">
        <div className="container nx-footer__pay-inner">
          <div className="nx-footer__pay-label">支援付款</div>
          <div className="nx-footer__pay-list">
            {PAYMENT_LOGOS.map((p) => (
              <span key={p.name} className="nx-footer__pay-logo" title={p.name}>
                <img src={p.logo} alt={p.name} loading="lazy" />
              </span>
            ))}
            <span className="nx-footer__pay-logo nx-footer__pay-logo--text" title="超商代碼">
              7-11 · 全家
            </span>
          </div>
        </div>
      </div>

      <div className="nx-footer__bottom">
        <div className="container nx-footer__bottom-inner">
          <span>{t.footer.copyright}</span>
          <span className="nx-footer__legal">{t.footer.legal}</span>
        </div>
      </div>
    </footer>
  );
}
